import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { CartItem } from '../components/abstract-item-row/abstract-item-row';

@Injectable()
export class DataLayerService {
    protected removedSource = new Subject();
    protected selectFreightSource = new Subject();
    protected selectPaymentMethodSource = new Subject();
    protected finalizedSource = new Subject();
    public removed$ = this.removedSource.asObservable();
    public selectFreight$ = this.selectFreightSource.asObservable();
    public selectPaymentMethod$ = this.selectPaymentMethodSource.asObservable();
    public finalized$ = this.finalizedSource.asObservable();

    public removed(item: CartItem) {
        this.removedSource.next(item);
    }
    public selectFreight(freight) {
        this.selectFreightSource.next(freight);
    }
    public selectPaymentMethod(paymentMethod) {
        this.selectPaymentMethodSource.next(paymentMethod);
    }
    public finalized(offers) {
        this.finalizedSource.next(offers);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/data-layer/data-layer.service.ts